import React, { useState, useRef, useEffect, useMemo } from "react";
import "../ChatBubble.css";
import Tooltip from "./CustomTooltip";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Responsewidget from "./ResponseWidget";
import Keyword from "./Keyword";
import MarkmapPopup from "./MarkmapPopup";
import ImageContaier from "./ImagePopup";
import TabbedPopup from "./TabbedPopup";
import Relatedtopic from "./RelatedTopics";
import SpeechButton from "./SpeechButton";
import { useLocation } from "react-router-dom";
import { createMyNote, getMyNotesSubjects } from "../services/myNotesService";
import { createChatSelectionNoteDraft } from "../utils/myNotes";
import EditNoteModal from "./MyNotes/EditNoteModal";
import NoteToast from "./MyNotes/NoteToast";
import share from "../assets/images/share.svg";
import { normalizeCards } from "../utils/mentorMindResponse";
import { getFirstItemsHeight } from "../utils/listScrollHeight";
// import { uploadPdfService } from "../services/Evaluation";
// import { revisePyq } from "../services/toolKit";
const ChatBubble = ({
  revise,
  setRevise,
  popup,
  setPopup,
  evaluatequestion,
  attchsubject,
  setMessageId,
  messageIdList,
  messageId,
  setShareUrl,
  isScrolling,
  setSharePopupPos,
  setShowSharePopup,
  selectEdit,
  promptType,
  isHistory,
  isStreamingDone,
  index,
  type,
  message,
  sender,
  evaluateResponse,
  suggestedquestions,
  userPrompt,
  loading,
  isLoading,
  error,
  onSend,
  chatUniqueIndex,
  copyContent,
  isCopied,
  isGeneratedPdf,
  isFeedbackFormSubmitted,
  generatePdf,
  getfeedbackform,
  reference,
  questionsMap,
  fetchQuestions,
  imageMap,
  relatedTopicsData,
  relatedTopicsLoading,
  relatedSummariesData,
  relatedSummariesLoading,
  keywords,
  caseStudies,
  initiatives,
  markmapData,
  onStartTest,
  keywordsArray,
  messages,
  evalStatus,
  setMessages,
  onExamToolkitOpen,
  syllabusProgressData,
  syllabusProgressLoading,
}) => {
  if (isStreamingDone && keywordsArray) {
  }
  // console.log(caseStudies);
  // // console.log(message, "message chatbubble 69");
  // // console.log(sender, "sender");
  // console.log(message, "uploadPdfService");
  // console.log("evalStatus --------", evalStatus);
  const location = useLocation();

  const checkscroll = useRef(null);
  // const [shareUrl, setShareUrl] = useState("");
  const [pyqData, setPyqData] = useState({
    pyq: "",
    revise: "",
  });
  const [activeButton, setActiveButton] = useState("mains");
  const [toolkit, setToolkit] = useState(false);
  const [noteview, setNoteView] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [viewImage, setViewImage] = useState(false);
  const [ModelAnswer, setModelAnswer] = useState(false);
  const [show, setShow] = useState(true);
  const [showMarkmap, setShowMarkmap] = useState(false);
  const [showTabbedPopup, setShowTabbedPopup] = useState(false);
  const [showExamToolkit, setShowExamToolkit] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const pyqListRef = useRef(null);
  const [pyqListHeight, setPyqListHeight] = useState(null);
  const speechButtonRef = useRef(null);
  const [topicKeyword, setTopicKeyword] = useState("");
  const [fetchingRevise, setFetchingRevise] = useState(false);
  const [loader, setLoader] = useState(true);
  const messagesStartRef = useRef(null);
  const [editNoteDraft, setEditNoteDraft] = useState(null);
  const [showEditNoteModal, setShowEditNoteModal] = useState(false);
  const [isSavingEditNote, setIsSavingEditNote] = useState(false);
  const [noteSubjects, setNoteSubjects] = useState([]);
  const [noteToastMessage, setNoteToastMessage] = useState("");
  const [noteToastVariant, setNoteToastVariant] = useState("success");
  const clampPopupToViewport = (x, y) => {
    const margin = 12;
    const safeX = Math.min(Math.max(x, margin), window.innerWidth - margin);
    const safeY = Math.min(Math.max(y, margin), window.innerHeight - margin);
    return { x: safeX, y: safeY };
  };

  const [isUserScrolling, setIsUserScrolling] = useState(false);

  const handleUserScroll = () => {
    setIsUserScrolling(true);
    // Optionally, you can set a timer to reset this after some time
    setTimeout(() => {
      isUserScrolling = false;
    }, 2000);
  };

  const handleMouseUp = () => {
    const selection = window.getSelection();
    const selectedText = selection?.toString() || "";
    const getSelectionStartRect = () => {
      if (!selection?.rangeCount || !selection.anchorNode) {
        return null;
      }

      try {
        const anchorRange = document.createRange();
        const anchorNode = selection.anchorNode;
        const maxOffset =
          anchorNode.nodeType === Node.TEXT_NODE
            ? anchorNode.textContent?.length || 0
            : anchorNode.childNodes?.length || 0;
        const safeOffset = Math.min(selection.anchorOffset || 0, maxOffset);

        anchorRange.setStart(anchorNode, safeOffset);
        anchorRange.setEnd(anchorNode, safeOffset);

        const anchorRect = anchorRange.getBoundingClientRect();
        if (anchorRect && (anchorRect.width || anchorRect.height)) {
          return anchorRect;
        }
      } catch (error) {
        // Fallback to selected range below.
      }

      return selection.getRangeAt(0).getBoundingClientRect();
    };

    if (
      selectedText.trim() &&
      selection?.rangeCount > 0 &&
      reference.current?.contains(selection.anchorNode)
    ) {
      const rect = getSelectionStartRect();
      if (!rect) {
        return;
      }
      const popupPoint = clampPopupToViewport(
        rect.left + rect.width / 2,
        rect.top - 12,
      );
      setPopup({
        visible: true,
        x: popupPoint.x,
        y: popupPoint.y,
        text: selectedText,
        messageIndex: index,
      });
    } else {
      setPopup({ ...popup, visible: false });
    }
  };

  const handleDocumentSelectionEnd = (event) => {
    const selection = window.getSelection();
    const selectedText = selection?.toString() || "";
    const container = reference.current;
    const getSelectionStartRect = () => {
      if (!selection?.rangeCount || !selection.anchorNode) {
        return null;
      }

      try {
        const anchorRange = document.createRange();
        const anchorNode = selection.anchorNode;
        const maxOffset =
          anchorNode.nodeType === Node.TEXT_NODE
            ? anchorNode.textContent?.length || 0
            : anchorNode.childNodes?.length || 0;
        const safeOffset = Math.min(selection.anchorOffset || 0, maxOffset);

        anchorRange.setStart(anchorNode, safeOffset);
        anchorRange.setEnd(anchorNode, safeOffset);

        const anchorRect = anchorRange.getBoundingClientRect();
        if (anchorRect && (anchorRect.width || anchorRect.height)) {
          return anchorRect;
        }
      } catch (error) {
        // Fallback to selected range below.
      }

      return selection.getRangeAt(0).getBoundingClientRect();
    };

    if (!selectedText.trim() || !selection?.rangeCount) {
      if (!event?.target?.closest?.(".text-selection-popup")) {
        setPopup({ visible: false, x: 0, y: 0, text: "" });
      }
      return;
    }

    if (!container) {
      return;
    }

    const range = selection.getRangeAt(0);
    const anchorInside = container.contains(selection.anchorNode);
    const focusInside = container.contains(selection.focusNode);
    const startInside = container.contains(range.startContainer);
    const endInside = container.contains(range.endContainer);

    if (!(anchorInside || focusInside || startInside || endInside)) {
      return;
    }

    const rect = getSelectionStartRect();
    if (!rect) {
      return;
    }
    const popupPoint = clampPopupToViewport(
      rect.left + rect.width / 2,
      rect.top - 12,
    );

    setPopup({
      visible: true,
      x: popupPoint.x,
      y: popupPoint.y,
      text: selectedText,
      messageIndex: index,
    });
  };

  const handleQuestionClickSelect = (question, subject) => {
    // const selectedQuestion = question.replace(/\[.*?\]$/, "").trim();
    let payload;
    payload = {
      message: question,
      prompt: subject,
    };
    setPopup({ visible: false, x: 0, y: 0, text: "" });
    isStreamingDone && onSend(payload);
  };
  useEffect(() => {
    const messagesContainer = document.querySelector(".chat-bubble");
    if (messagesContainer) {
      messagesContainer.addEventListener("scroll", handleUserScroll);
      return () => {
        messagesContainer.removeEventListener("scroll", handleUserScroll);
      };
    }
  }, []);

  useEffect(() => {
    if (messagesStartRef.current) {
      const rect = messagesStartRef.current.getBoundingClientRect();
      if (rect.top > 0) {
        messagesStartRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [message, index]);

  // useEffect(() => {
  //   if (!revise) {
  //     fetchingRevise.current = false;
  //     return;
  //   }

//   //   const callRevisePyq = async () => {
//  //       console.log("call callRevisePyq: chatbubble 172");
//       setLoader(true);
//   //     try {
//   //       // Guard against out of bounds or missing messages
//   //       if (messages.length < 2) {
//   //         setRevise(false);
//   //         return;
//   //       }

//   //       console.log(messages, "testmessgs chatBubble");
//   //       const userMsg = messages[messages.length - 2];
//   //       const botMsg = messages[messages.length - 1];

//   //       if (!botMsg || !botMsg.messageId || botMsg.messageId === "null" || botMsg.messageId === "undefined") {
//   //         console.warn("Message ID is not available from mentormind, skipping PYQ revision to avoid msg_id not found error.");
//   //         setRevise(false);
//   //         setLoader(false);
//   //         return;
//   //       }

//   //       const response = await revisePyq(userMsg.message, botMsg.messageId);
//  console.log("pyq response:", response);
//   //       setPyqData({
//   //         pyq: response.pyq,
//   //         revise: response.revise,
//   //       });

//   //       setMessages((prev) =>
//   //         prev.map((msg, i) =>
//   //           i === index && (!msg.pyq || !msg.revise)
//   //             ? { ...msg, pyq: response.pyq, revise: response.revise }
//   //             : msg,
//   //         ),
//   //       );

//   //       console.log("PYQ Revised:", response);
//   //     } catch (error) {
//   //       console.error("Failed to revise PYQ:", error);
//   //     } finally {
//   //       setRevise(false);
//   //       setLoader(false);
//   //     }
//   //   };

  //   // Only the last message's bubble should handle this check to prevent multiple instances from calling the API
  //   if (
  //     index === messages.length - 1 &&
  //     sender === "bot" &&
  //     !fetchingRevise.current &&
  //     messages[index]?.messageId &&
  //     (messages[index]?.prompt === "Quick Topic Summary" ||
  //       messages[index]?.prompt === "Generic")
  //   ) {
  //     fetchingRevise.current = true;
  //     callRevisePyq();
  //   }
  // }, [revise, index, messages, sender, setMessages, setRevise]);

  useEffect(() => {
    if (sender === "bot" && reference.current && message) {
      const responseDiv = reference.current;
      responseDiv.scrollTop = responseDiv.scrollHeight;
    }
  }, [message]);

  useEffect(() => {
    const handleSelectionKeyUp = (event) => {
      const navigationKeys = [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
        "PageUp",
        "PageDown",
      ];

      if (event.shiftKey && navigationKeys.includes(event.key)) {
        handleMouseUp();
      }
    };

    document.addEventListener("keyup", handleSelectionKeyUp);
    return () => {
      document.removeEventListener("keyup", handleSelectionKeyUp);
    };
  }, [popup, reference, index]);

  useEffect(() => {
    document.addEventListener("mouseup", handleDocumentSelectionEnd);
    return () => {
      document.removeEventListener("mouseup", handleDocumentSelectionEnd);
    };
  }, [index, reference]);

  const IMG = (imgName) => {
    return `assets/landingpage/images/${imgName}`;
  };
  // useEffect(() => {
  //   if (speechButtonRef.current && !isStreamingDone) {
  //     speechButtonRef.current.stopSound();
  //   }
  // }, []);

  const handleQuestionClick = (question, subject) => {
    // const selectedQuestion = question.replace(/\[.*?\]$/, "").trim();
    let payload;
    if (subject && subject.toLowerCase() === "essay") {
      payload = {
        message: question,
        prompt: "Essay",
      };
    } else {
      payload = {
        message: question,
        prompt: "See a Model Answer",
      };
    }
    onSend(payload);
  };

  const handleShowModelAnswer = () => {
    const payload = {
      message: message,
      prompt: "model",
    };
    onSend(payload);
  };

  const renderEvaluate = () => {
    if (!evaluateResponse) return null;
    return (
      <div>
        <div className="response-container w-100 m-0">
          <div className="table-container">
            <table className="rating-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Poor</th>
                  <th>Average</th>
                  <th>Good</th>
                  <th>Very Good</th>
                  <th>Excellent</th>
                </tr>
              </thead>
              <tbody>
                {evaluateResponse.ratingTable.map(
                  ({ criteria, rating }, index) => (
                    <tr key={index}>
                      <th>{criteria}</th>
                      {[
                        "Poor",
                        "Average",
                        "Good",
                        "Very Good",
                        "Excellent",
                      ].map((level) => (
                        <td
                          key={level}
                          className={rating === level ? "td-custom" : ""}
                        >
                          {rating === level ? (
                            <img
                              src="/assets/images/check.png"
                              className="check-image"
                              alt="Tick Mark"
                            />
                          ) : null}
                        </td>
                      ))}
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          </div>

          <div>
            <b>Things to improve:</b>
          </div>
          <div className="improvement-section">
            {evaluateResponse.improvementSuggestions.map(
              (suggestion, index) => (
                <p key={index}>{suggestion}</p>
              ),
            )}
          </div>

          <div className="score-section">
            <img src="/assets/images/star.png" alt="star" /> Score:{" "}
            {evaluateResponse.score.value}/{evaluateResponse.score.total}
          </div>
        </div>
        <button
          className="btn-evaluate-mark evaluate-marks mt-3"
          onClick={handleShowModelAnswer}
        >
          Generate Model Answer
        </button>
      </div>
    );
  };

  function cleanText(text) {
    // Remove any text that starts with a square bracket and ends with a square bracket
    const question = text.replace(/\s*\[\d{4}.*?\]\s*/g, "").trim();
    return question;
  }

  function htmlToPlainText(html) {
    if (!html) return "";

    // Create a temporary div element to parse HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Remove all pre and code elements and their contents
    const preElements = tempDiv.querySelectorAll("pre");
    preElements.forEach((pre) => pre.remove());

    const codeElements = tempDiv.querySelectorAll("code");
    codeElements.forEach((code) => code.remove());
    const tableElements = tempDiv.querySelectorAll("table");
    tableElements.forEach((code) => code.remove());

    // Get the text content without HTML tags
    const plainText = tempDiv.textContent || tempDiv.innerText || "";

    // Clean up extra whitespace and return
    return plainText.replace(/\s+/g, " ").trim();
  }

  const handleAddSelectionToNotes = (messageIndex) => {
    if (!popup.text?.trim()) {
      return;
    }

    const selectedText = popup.text.trim();
    const noteDraft = createChatSelectionNoteDraft({
      selectedText,
      tag: messages[messageIndex]?.subject || "",
    });

    setEditNoteDraft(noteDraft);
    setShowEditNoteModal(true);
    setPopup({ visible: false, x: 0, y: 0, text: "" });
  };

  const handleEditNoteSave = async (noteData) => {
    setIsSavingEditNote(true);
    try {
      await createMyNote(noteData);
      setShowEditNoteModal(false);
      setEditNoteDraft(null);
      setPopup({ visible: false, x: 0, y: 0, text: "" });
    } catch (noteError) {
      console.error("Failed to create note from selection:", noteError);
    } finally {
      setIsSavingEditNote(false);
    }
  };

  const handleEditNoteClose = () => {
    setShowEditNoteModal(false);
    setEditNoteDraft(null);
  };

  useEffect(() => {
    let cancelled = false;

    getMyNotesSubjects()
      .then((subjects) => {
        if (!cancelled) {
          setNoteSubjects(subjects);
        }
      })
      .catch((error) => {
        console.error("Failed to load note subjects", error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleSaveWholeContext = () => {
    if (!message || !message.trim()) return;

    let contentHtml = message;
    if (reference.current) {
      contentHtml = reference.current.innerHTML;
    }

    const title = messages[index-1]?.message;
    const subjectTag = messages[index]?.subject || "Chat";

    const noteDraft = {
      title: title,
      content: `<div>${contentHtml}</div>`,
      tags: [subjectTag],
      attachments: [],
    };

    setEditNoteDraft(noteDraft);
    setShowEditNoteModal(true);
  };

  useEffect(() => {
    return () => {
      if (speechButtonRef.current) {
        // Try multiple possible method names
        const stopMethods = [
          "stopSound",
          "stop",
          "pause",
          "stopSpeech",
          "cancel",
        ];

        for (const method of stopMethods) {
          if (typeof speechButtonRef.current[method] === "function") {
            try {
              speechButtonRef.current[method]();
              break;
            } catch (e) {
              console.warn(`Error calling ${method}:`, e);
            }
          }
        }
      }
    };
  }, []);

  const pyqQuestions = questionsMap?.[index]?.suggestedQuestions || [];
  const showPyqScroll = pyqQuestions.length > 3;

  // Size the PYQ list to exactly three visible questions, then scroll.
  useEffect(() => {
    if (activeSection !== "mainPyq" || !showPyqScroll) {
      setPyqListHeight(null);
      return undefined;
    }

    let cancelled = false;
    const measure = () => {
      if (cancelled) return;
      setPyqListHeight(getFirstItemsHeight(pyqListRef.current, 3));
    };

    measure();
    window.addEventListener("resize", measure);
    if (document.fonts?.ready) {
      document.fonts.ready.then(measure).catch(() => {});
    }

    return () => {
      cancelled = true;
      window.removeEventListener("resize", measure);
    };
  }, [activeSection, showPyqScroll, questionsMap]);

  function getyear(text) {
    const yearMatch = text.match(/\[(\d{4})/);
    const year = yearMatch ? yearMatch[1] : null;
    return year;
  }
  function getExamPaper(text) {
    const match = text.match(/\[(.*?)\]/); // Matches text inside brackets
    if (match && match[1]) {
      const parts = match[1].split("-");
      if (parts.length > 1) {
        return parts[1].trim(); // Returns "Mains GS Paper I"
      }
    }
    return ""; // If format doesn't match
  }

  // Function to unwrap evaluation HTML from pre/code tags
  function unwrapEvaluationHTML(html) {
    if (!html) return html;

    return String(html).replace(
      /<pre><code(?:\s+class="language-html")?>([\s\S]*?)<\/code><\/pre>/gi,
      (full, content) => {
        if (/card-uni|_className_|class="country"|class="heading"/i.test(content)) {
          return "";
        }
        const decoded = content
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&quot;/g, '"')
          .replace(/&#039;/g, "'")
          .replace(/&amp;/g, "&");
        if (/card-uni|_className_|class="country"/i.test(decoded)) {
          return "";
        }
        if (/<(?:div|p|h[1-6]|span|table)\b/i.test(decoded)) {
          return decoded;
        }
        return full;
      },
    );
  }

  const isEvaluatePrompt =
    type?.toLowerCase() === "evaluate" ||
    promptType?.toLowerCase() === "evaluate" ||
    messages[index]?.prompt?.toLowerCase() === "evaluate";

  const evaluateStatus = messages[index]?.evalStatus;

  const isEvaluationAccepted =
    isEvaluatePrompt &&
    (!evaluateStatus || evaluateStatus === "accepted");

  return (
    <>
      {popup.visible && popup.messageIndex === index && (
        <div
          className="text-selection-popup"
          style={{
            position: "fixed",
            top: popup.y - 30,
            left: popup.x,
            transform: "translate(-50%, 0)",
            background: "white",
            // border: "1px solid #ddd",
            // padding: "6px 10px",
            borderRadius: "8px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
            zIndex: 1000,
            display: "flex",
            gap: "8px",
          }}
          onMouseDown={(e) => e.stopPropagation()} // 👈 prevents closing popup
        >
          {/* // by sudz - 260930 - Compact selection popup buttons with font size < 14px */}
          <button
            style={{
              outline: "none",
              border: "1px solid #F5D5B1",
              backgroundColor: "#FFE8D9",
              color: "#1E293B",
              borderRadius: "4px",
              cursor: "pointer",
              background: "linear-gradient(90deg, #FFE8D9 0%, #FFFAF4 100%)",
              fontSize: "12px",
              padding: "4px 8px",
            }}
            onClick={() => {
              handleQuestionClickSelect(popup.text, "Quick Topic Summary");
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 16 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5855 14.3123C15.5855 18.5581 12.0966 22 7.79275 22C3.48893 22 0 18.5581 0 14.3123C0 10.0665 3.48893 6.62454 7.79275 6.62454C12.0966 6.62454 15.5855 10.0665 15.5855 14.3123ZM3.76964 14.3123C3.76964 16.5042 5.57085 18.2812 7.79275 18.2812C10.0146 18.2812 11.8158 16.5042 11.8158 14.3123C11.8158 12.1203 10.0146 10.3434 7.79275 10.3434C5.57085 10.3434 3.76964 12.1203 3.76964 14.3123Z"
                    fill="#F59C36"
                  />
                  <path
                    d="M9.56131 14.3123C9.56131 15.2759 8.7695 16.057 7.79275 16.057C6.81599 16.057 6.02418 15.2759 6.02418 14.3123C6.02418 13.3487 6.81599 12.5675 7.79275 12.5675C8.7695 12.5675 9.56131 13.3487 9.56131 14.3123Z"
                    fill="#F59C36"
                  />
                  <path
                    d="M16 0L9.56131 4.28005C12.9658 4.84709 15.1065 6.80628 15.7513 7.71499L16 0Z"
                    fill="#F59C36"
                  />
                </svg>
              </span>
              <p
                style={{
                  margin: "0px",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "1.2",
                }}
              >
                Askyooki
              </p>
            </div>
          </button>
          <button
            style={{
              outline: "none",
              border: "1px solid #B1E0F5",
              color: "#1E293B",
              borderRadius: "4px",
              cursor: "pointer",
              background: "linear-gradient(90deg, #D9F4FF 0%, #F4FCFF 100%)",
              fontSize: "12px",
              padding: "4px 8px",
            }}
            onClick={() => handleAddSelectionToNotes(popup.messageIndex)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="../assets/images/my_notes_new_sidebar_active.svg"
                  alt="Save Notes"
                  height={15}
                  width={15}
                />
              </span>
              <p
                style={{
                  margin: "0px",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "1.2",
                  whiteSpace: "nowrap",
                }}
              >
                Save Notes
              </p>
            </div>
          </button>
        </div>
      )}

      <div
        className={`chat-bubble  ${
          sender === "user" ? "user" : "bot w-100 p-0 d-flex"
        }`}
        ref={checkscroll}
      >
        {!isScrolling && <div ref={messagesStartRef}></div>}
        {sender === "user" && message ? (
          <>
            <span className="type-message">{type ? type : "Generic"}</span>
            <div></div>
            <div
              ref={reference}
              className={`user-msg response-area botChat w-100 ${chatUniqueIndex}`}
              dangerouslySetInnerHTML={{
                __html: unwrapEvaluationHTML(message),
              }}
            ></div>
          </>
        ) : sender === "bot" &&
          !message &&
          index !== messages.length - 1 ? null : sender === "bot" ? (
          <>
            <div className="d-flex botImage">
              {!(isLoading && index === messages.length - 1 && !message) && (
              <img
                src="/assets/images/logo/yooki_navigator.svg"
                className="botImage-img"
                alt="response loading"
              ></img>
              )}
              {!message && !isHistory && !isLoading ? (
                <div
                  className="d-flex dots"
                  style={{ alignItems: "center", padding: "12px 0" }}
                >
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              ) : type === "Evaluate" ? (
                renderEvaluate()
              ) : (
                <div
                  ref={reference}
                  className={`response-area dev botChat w-100 ${chatUniqueIndex}`}
                  dangerouslySetInnerHTML={{
                    __html: unwrapEvaluationHTML(message),
                  }}
                  onMouseUp={() => {
                    handleMouseUp();
                    const selectedText = window.getSelection().toString();
                    if (selectedText.trim()) {
                    }
                  }}
                ></div>
              )}
            </div>
          </>
        ) : null}

        {!questionsMap[index] && loading && isStreamingDone && (
          <p className="content-div">Loading...</p>
        )}
        {error[index] && <p style={{ color: "red" }}>{error[index].error}</p>}

        {/* {message && sender == "bot" &&  !message.hasStatusMatch && (
          <div className="chatcopyContainer">
            { keywordsArray && keywordsArray.length>0 && (
<>
<span
              className="copy-icon"
              onClick={(e) => {
                copyContent(chatUniqueIndex);
              }}
            >
              
              <Tooltip text="Copy" position="bottom">
                <img src="assets/images/Copy1.svg" alt="copy" />
              </Tooltip>
            </span>

            <span
              className="copy-icon"
              onClick={(e) => {
                generatePdf(chatUniqueIndex, index);
              }}
            >
              <Tooltip text="Download" position="bottom">
                <img src="assets/images/download.svg" alt="download" />
              </Tooltip>
            </span>
</>
            ) }     
           

            <span
              className="copy-icon"
              onClick={(e) => {
                getfeedbackform();
              }}
            >
              
              <Tooltip text="Feedback" position="bottom">
                <img src="assets/images/Feedback1.svg" alt="Feedback" />
              </Tooltip>
            </span>
            <span
              className={`copy-icon ${
                promptType === "Evaluate" ? "d-none" : ""
              }`}
              onClick={(e) => {
                selectEdit("", index);
              }}
            >
              
              <Tooltip text="Edit" position="bottom">
                <img src="assets/images/EditQuery.svg" alt="Edit" />
              </Tooltip>
            </span>
            <span
              className={`copy-icon speech-icon ${
                promptType === "Evaluate" ? "d-none" : ""
              }`}
              
            >
              <Tooltip text="Speech" position="bottom">
                <SpeechButton 
                ref={speechButtonRef}
                content={htmlToPlainText(message)}
                size={20}
                showTimer={false}
              />
              </Tooltip>
            </span>
            {markmapData && markmapData[index] &&<span
              className="copy-icon"
              onClick={(e) => {
                setShowMarkmap(true);
              }}
            >
              <Tooltip text="Infographic" position="bottom">
              <img src="assets/images/Infographic2.svg" alt="info" />
              </Tooltip>
            </span>}
            {isCopied ? <span className="copied">Copied!</span> : null}
            {isGeneratedPdf ? (
              <span className="copied">Downloaded!</span>
            ) : null}
            {isFeedbackFormSubmitted ? (
              <span className="copied">Feedback Submitted!</span>
            ) : null}
          </div>
        )} */}

        <div>
          {/* {sender === "bot" && keywords && !message.hasStatusMatch && (
            <Keyword keywords={keywords} />
          )} */}
          {/* {sender === "bot" && isStreamingDone && <Responsewidget />} */}

          {sender === "bot" &&
            !message.hasStatusMatch &&
            (caseStudies ||
              initiatives ||
              questionsMap[index]?.suggestedQuestions?.length > 0 ||
              keywordsArray?.length > 0) && (
              <div className="data-toggle-container">
                <div className="data-toggle-buttons">
                  {caseStudies && (
                    <div
                      className={`data-toggle-btn ${activeSection === "caseStudies" ? "active" : ""}`}
                      onClick={() =>
                        setActiveSection(
                          activeSection === "caseStudies" ? null : "caseStudies",
                        )
                      }
                    >
                      <img src="/assets/images/case-study.svg" alt="" />
                      <span>Case Studies</span>
                    </div>
                  )}
                  {initiatives && (
                    <div
                      className={`data-toggle-btn ${activeSection === "initiatives" ? "active" : ""}`}
                      onClick={() =>
                        setActiveSection(
                          activeSection === "initiatives" ? null : "initiatives",
                        )
                      }
                    >
                      <img src="/assets/images/Initiatives-icon-new.svg" alt="" />
                      <span>Initiatives</span>
                    </div>
                  )}
                  {questionsMap[index]?.suggestedQuestions?.length > 0 && (
                    <div
                      className={`data-toggle-btn ${activeSection === "mainPyq" ? "active" : ""}`}
                      onClick={() =>
                        setActiveSection(
                          activeSection === "mainPyq" ? null : "mainPyq",
                        )
                      }
                    >
                      <img src="/assets/images/Follow-up-questions.svg" alt="" />
                      <span>Mains PYQ</span>
                    </div>
                  )}
                  {keywordsArray?.length > 0 && (
                    <div
                      className={`data-toggle-btn ${activeSection === "prelimsPyq" ? "active" : ""}`}
                      onClick={() =>
                        setActiveSection(
                          activeSection === "prelimsPyq" ? null : "prelimsPyq",
                        )
                      }
                    >
                      <img src="/assets/images/related-3.svg" alt="" />
                      <span>Prelims PYQs</span>
                    </div>
                  )}
                </div>

                {activeSection === "caseStudies" && caseStudies && (
                  <div
                    className="data-toggle-content data-grid"
                    dangerouslySetInnerHTML={{
                      __html: normalizeCards(caseStudies) || caseStudies,
                    }}
                    onClick={(e) => {
                      if (!isStreamingDone) return;
                      const card = e.target.closest(".card-uni");
                      if (!card) return;
                      const country =
                        card.querySelector(".country")?.textContent || "";
                      const heading =
                        card.querySelector(".heading")?.textContent || "";
                      const text = `Give me a detailed explanation of the programme '${heading}' in '${country}'.`;
                      onSend({ message: text, prompt: "Explore a Case Study" });
                    }}
                  />
                )}

                {activeSection === "initiatives" && initiatives && (
                  <div
                    className="data-toggle-content data-grid"
                    dangerouslySetInnerHTML={{
                      __html: normalizeCards(initiatives) || initiatives,
                    }}
                    onClick={(e) => {
                      if (!isStreamingDone) return;
                      const card = e.target.closest(".card-uni");
                      if (!card) return;
                      const country =
                        card.querySelector(".country")?.textContent || "";
                      const heading =
                        card.querySelector(".heading")?.textContent || "";
                      const text = `Give me a detailed explanation of the programme '${heading}' in '${country}'.`;
                      onSend({ message: text, prompt: "" });
                    }}
                  />
                )}

                {activeSection === "mainPyq" &&
                  questionsMap[index]?.suggestedQuestions?.length > 0 && (
                    <div
                      ref={pyqListRef}
                      className={`data-toggle-content data-row${
                        showPyqScroll ? " pyq-row-scroll" : ""
                      }`}
                      style={
                        showPyqScroll && pyqListHeight
                          ? { maxHeight: `${pyqListHeight}px` }
                          : undefined
                      }
                    >
                      {questionsMap[index].suggestedQuestions.map((question) => (
                        <div
                          key={question.id}
                          className="pyq-row-item"
                          onClick={() => {
                            if (isStreamingDone) {
                              const cleanQ = question.question.replace(
                                /\s*\[\d{4}.*?\]\s*/g,
                                "",
                              ).trim();
                              const payload =
                                question.subject?.toLowerCase() === "essay"
                                  ? { message: cleanQ, prompt: "Essay" }
                                  : {
                                      message: cleanQ,
                                      prompt: "See a Model Answer",
                                    };
                              onSend(payload);
                            }
                          }}
                        >
                          <span className="pyq-row-question">{question.question.replace(/\s*\[\d{4}.*?\]\s*/g, "").trim()}</span>
                          <span className="subject-year">
                            <span className="que-con" style={{ marginRight: "10px" }}>
                              {question.subject}
                            </span>
                            <span className="que-con">{question.year}</span>
                          </span>
                        </div>
                      ))}
                    </div>
                  )}

                {activeSection === "prelimsPyq" &&
                  keywordsArray?.length > 0 && (
                    <div className="data-toggle-content prelims-pyq-content">
                      <p className="prelims-pyq-hint">Take a Practice Test</p>
                      <div className="prelims-pyq-keywords">
                        {keywordsArray.map((keyword, keywordIndex) => (
                          <button
                            key={`${keyword}-${keywordIndex}`}
                            type="button"
                            className="prelims-pyq-keyword-btn"
                            onClick={() => {
                              if (isStreamingDone && onStartTest) {
                                onStartTest(keyword);
                              }
                            }}
                          >
                            {keyword} +
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                {activeSection && (
                  <div
                    className="data-toggle-collapse"
                    onClick={() => setActiveSection(null)}
                  >
                    <span>Collapse</span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M6 8L2 4H10L6 8Z" fill="#7B869B"/>
                    </svg>
                  </div>
                )}
              </div>
            )}

          {messages[index].sender === "bot" &&
            (
              messages[index].prompt != "Frame Your Essay") &&
            !messages[index].context &&
            keywordsArray &&
            keywordsArray.length > 0 && (
              <div className="evaluate-onsend-div">
                <span className="evaluate-onsend-div-text">
                  <img src="/assets/images/evaluate_star.svg" alt="" />{" "}
                  {!messages[index].revise ? (
                    isHistory ? null : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        position: "relative",
                      }}
                    >
                      <Skeleton height={30} width={200} />
                      <div
                        style={{
                          top: "8px",
                          left: "20px",
                          position: "absolute",
                        }}
                      >
                        Preparing Your Exam Toolkit
                      </div>
                    </div>
                    )
                  ) : (
                    <div>
                      {" "}
                        <span
                          className="exam-toolkit-buto"
                          onClick={() => {
                            onExamToolkitOpen && onExamToolkitOpen(index);
                          }}
                        >
                        Exam Toolkit
                      </span>
                    </div>
                  )}
                  Analyze PYQs, Memorize and Revise like a Topper.
                </span>
              </div>
            )}


          {message && sender == "bot" && !message.hasStatusMatch && (
            <div className="chatcopyContainer">
              <div className="left-copy-icon-div">
                {keywordsArray && keywordsArray.length > 0 && (
                  <span
                    className="copy-icon left-icon"
                    onClick={(e) => {
                      copyContent(chatUniqueIndex);
                    }}
                  >
                    <img src="/assets/images/Copy1.svg" alt="copy" />
                    <span className="icon-text">Copy</span>
                  </span>
                )}

                {(keywordsArray?.length > 0 ||
                  isEvaluationAccepted) && (
                  <>
                    <span
                      className="copy-icon left-icon"
                      onClick={(e) => {
                        generatePdf(chatUniqueIndex, index);
                      }}
                    >
                      <img src="/assets/images/download.svg" alt="download" />
                      <span className="icon-text">Download</span>
                    </span>
                    <span
                      className={`copy-icon left-icon index-${index}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        const rect = e.currentTarget.getBoundingClientRect();

                        setSharePopupPos({
                          top: rect.bottom + window.scrollY + 8,
                          left: rect.left + window.scrollX,
                        });
                        // Remove existing /message/{id} if present

                        const url = `${window.location.origin}/chat/message/${messages[index].messageId}`;

                        setShareUrl(url);

                        setShowSharePopup((prev) => !prev);

                        navigator.clipboard.writeText(url);
                      }}
                    >
                      <img src={share} alt="share" />
                      <span className="icon-text">Share</span>
                    </span>
                  </>
                )}
                <span
                  className={`copy-icon left-icon ${
                    promptType === "Evaluate" || isEvaluatePrompt
                      ? "d-none"
                      : ""
                  }`}
                  onClick={(e) => {
                    selectEdit("", index);
                  }}
                >
                  <img src="/assets/images/EditQuery.svg" alt="Edit" />
                  <span className="icon-text">Edit</span>
                </span>
                {(keywordsArray?.length > 0 ||
                  isEvaluationAccepted) && (
                  <span
                    className="copy-icon left-icon"
                    onClick={handleSaveWholeContext}
                  >
                    <img src="/assets/images/note-2.svg" alt="save note" style={{width:"20px",height:"20px"}} />
                    <span className="icon-text">Save to My Notes</span>
                  </span>
                )}

                <span className="action-messages">
                  {isCopied ? <span className="copied">Copied!</span> : null}
                  {isGeneratedPdf ? (
                    <span className="copied">Downloaded!</span>
                  ) : null}
                  {isFeedbackFormSubmitted ? (
                    <span className="copied">Feedback Submitted!</span>
                  ) : null}
                </span>
              </div>

              <div className="right-copy-icon-div">
                <span
                  className="copy-icon right-icon"
                  onClick={(e) => {
                    setMessageId(messages[index].messageId);
                    getfeedbackform();
                  }}
                >
                  <span className="icon-text">Feedback</span>
                  <img src="/assets/images/Feedback1.svg" alt="Feedback" />
                </span>

                <span
                  className={`copy-icon right-icon speech-icon ${
                    promptType === "Evaluate" ? "d-none" : ""
                  }`}
                >
                  <span className="icon-text">Speech</span>
                  <SpeechButton
                    ref={speechButtonRef}
                    content={htmlToPlainText(message)}
                    size={20}
                    showTimer={false}
                  />
                </span>

                {/* <span
                  className="copy-icon"
                  onClick={handleSaveWholeContext}
                >
                  <Tooltip text="Save Note" position="bottom">
                    <img src="/assets/images/my_notes_new_sidebar_active.svg" alt="save note" style={{width:"25px",height:"30px"}} />
                  </Tooltip>
                </span> */}
                {/* {markmapData && markmapData[index] && (
                  <span
                    className="copy-icon"
                    onClick={(e) => {
                      setShowTabbedPopup(true);
                    }}
                  >
                    <Tooltip text="Infographic & Images" position="bottom">
                      <img src="assets/images/Infographic2.svg" alt="info" />
                    </Tooltip>
                  </span>
                } */}
              </div>
            </div>
          )}
          {sender === "bot" && messages[index].prompt == "evaluate" && (
            <div className="evaluate-onsend-div">
              <span className="evaluate-onsend-div-text">
                <img src="/assets/images/evaluate_star.svg" alt="" />
                See the ideal way to structure this answer for maximum impact.
              </span>
              <span
                className={`evaluate-onsend-div-button ${
                  !isStreamingDone || isLoading ? "disabled" : ""
                }`}
                onClick={() => {
                  if (isStreamingDone && !isLoading) {
                    onSend({
                      message: messages[index - 1].message,
                      prompt:
                        messages[index - 1].attchsubject != "Essay"
                          ? "See a Model Answer"
                          : "Frame Your Essay",
                    });
                  }
                }}
              >
                Generate Model Answer
              </span>
            </div>
          )}

          {showTabbedPopup && (
            <TabbedPopup
              markmapContent={
                markmapData && markmapData[index] ? markmapData[index] : null
              }
              imageMap={imageMap}
              index={index}
              onClose={() => (setShowTabbedPopup(false), setToolkit(false))}
              toolkit={toolkit}
              message={messages[index - 1].message}
              setMessages={setMessages}
              messages={messages}
              loader={loader}
            />
          )}
        </div>
      </div>

      {type != "Prelims Practice" && !message.hasStatusMatch ? (
        <div className="right-sidebar-area RelatedTopic-mob">
          {/* {sender === "bot" && (markmapData?.[index] || imageMap?.[index]) && (
            <div className="info-main-div">
              <div className="info-title-div">
                <p>
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.85156 6.13477V13.6348"
                      stroke="#7B869B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.85156 4.63477V15.1348"
                      stroke="#7B869B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.3516 3.13477H9.35156C8.52314 3.13477 7.85156 3.80634 7.85156 4.63477V15.1348C7.85156 15.9632 8.52314 16.6348 9.35156 16.6348H15.3516C16.18 16.6348 16.8516 15.9632 16.8516 15.1348V4.63477C16.8516 3.80634 16.18 3.13477 15.3516 3.13477Z"
                      stroke="#7B869B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>Infographics</span>
                </p>
              </div>
              <div
                className="info-container-div"
                onClick={() => setShowTabbedPopup(true)}
              >
                <img
                  // src={
                  //   imageMap &&
                  //     imageMap[index] &&
                  //     imageMap[index].image_link
                  //     ? "assets/images/Info-banner.svg" // ✅ both markmap & image exist
                  //     : "assets/images/Info-placeholder.svg" // ⚙️ only one exists
                  // }
                  src="/assets/images/Info-banner.svg"
                />
              </div>
            </div>
          )} */}

          {sender === "bot" &&
            type != "Essay Guidance" &&
            type != "evaluate" &&
            message.length > 0 && (
              <>
                {(relatedTopicsData?.length > 0 || relatedSummariesData?.length > 0 || syllabusProgressData || relatedSummariesLoading || syllabusProgressLoading) && (
                  <Relatedtopic
                    relatedTopicsData={relatedTopicsData}
                    relatedLoader={relatedTopicsLoading}
                    relatedSummariesData={relatedSummariesData}
                    relatedSummariesLoader={relatedSummariesLoading}
                    showOnlySummaries={true}
                    showpracticetest={false}
                    onStartTest={onStartTest}
                    keywords={keywordsArray}
                    setTopicKeyword={setTopicKeyword}
                    syllabusProgressData={syllabusProgressData}
                    syllabusProgressLoading={syllabusProgressLoading}
                  />
                )}
              </>
            )}
        </div>
      ) : null}

      {showEditNoteModal && editNoteDraft && (
        <EditNoteModal
          note={editNoteDraft}
          isSaving={isSavingEditNote}
          subjects={noteSubjects}
          onClose={handleEditNoteClose}
          onSave={handleEditNoteSave}
        />
      )}

      {noteToastMessage ? (
        <NoteToast
          message={noteToastMessage}
          variant={noteToastVariant}
          onClose={() => setNoteToastMessage("")}
        />
      ) : null}
    </>
  );
};

export default ChatBubble;
